import { ScopedCssBaseline } from '@mui/material';
import {
  createTheme,
  ThemeProvider as MUIThemeProvider,
  styled,
  StyledEngineProvider,
} from '@mui/material/styles';
import React, { useMemo } from 'react';
import typography from './typography/index';
import breakpoints from './breakpoints';
import palette from './palette';
import ComponentsOverrides from './overrides';

const StyledScopedCssBaseline = styled(ScopedCssBaseline)({
  fontFamily:
    // "'Suisse-Intl','Source_Sans_Pro-Regular','Roboto-Regular',Arial,Verdana,Sans Serif",
    "'FSSiena-Regular','Source_Sans_Pro-Regular','Roboto-Regular',Arial,Verdana,Sans Serif",
  backgroundColor: 'white',
});

export default function ThemeV5Provider({ children }) {
  // If need a Theme Dark mode, start here
  const isLight = true;

  const themeOptions = useMemo(
    () => ({
      palette: isLight ? palette.light : palette.dark,
      typography,
      breakpoints,
    }),
    [isLight]
  );

  const theme = createTheme(themeOptions);

  theme.components = ComponentsOverrides(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <StyledScopedCssBaseline>{children}</StyledScopedCssBaseline>
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
